/** Public-facing copy for Steward. One place, so every surface says the same thing. */
export const STEWARD_NAME = "Your Steward";

/** Honest, friendly disclosure shown under the workspace header. */
export const STEWARD_DISCLOSURE =
  "Your Steward is our AI concierge — here day and night.";
